import { useCallback } from "react";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { TEntityInfo } from "../../../../common/types/utility";
import { TModalsIds } from "../types";
import { updateModal } from "../slice";

export const useAppModals = () => {
  const dispatch = useAppDispatch();

  const handleOpenModal = useCallback(
    (modalId: TModalsIds, info: TEntityInfo | null, subtype?: string) => {
      dispatch(updateModal({ id: modalId, info: info, isOpen: true, subtype }));
    },
    [dispatch],
  );

  const handleCloseModal = useCallback(
    (modalId: TModalsIds, subtype?: string) => {
      dispatch(
        updateModal({
          id: modalId,
          info: null,
          isOpen: false,
          subtype: subtype,
        }),
      );
    },
    [dispatch],
  );

  return {
    handleOpenModal,
    handleCloseModal,
  };
};
